import React from "react";
import { PropTypes } from "prop-types";
import { MrbContentLoader } from "mrb/components/loader";
import { currencyFormatter } from "mrb/common/formatting";
import { observer } from "mobx-react";
import { AdminProducerSummaryLoader } from "administration/producer/components";

function ProducerSummaryPreviewTemplate({ producerRevenueViewStore, t }) {
    const { summaryData, loaderStore, producers } = producerRevenueViewStore;
    return (
        <div className="u-mar--bottom--sml">
            <h1 className="u-type--base u-mar--bottom--sml">Summary</h1>
            <div className="c-card--primary c-card--med">
                <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <AdminProducerSummaryLoader isUser />}>
                    {() => (
                        <div className="u-animation--fadeIn">
                            {summaryData && (
                                <div className="u-animation--fadeIn">
                                    {producers.length === 1 && (
                                        <React.Fragment>
                                            <div className="row u-mar--bottom--sml">
                                                <div className="col col-sml-7">
                                                    <p className="u-type--sml u-type--color--opaque">Producer</p>

                                                    <p className="u-display--flex u-display--flex--ai--center">
                                                        {summaryData.producerName}
                                                    </p>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    <div className="row">
                                        <div className="col col-sml-7">
                                            <p className="u-type--sml u-type--color--opaque">Account Balance</p>
                                            <div className="c-dashboard__count--increase">
                                                <p className="c-dashboard__count--lrg">
                                                    {currencyFormatter.format(
                                                        summaryData.accountBalance ? summaryData.accountBalance : 0,
                                                        {
                                                            currency: "USD",
                                                        }
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </MrbContentLoader>
            </div>
        </div>
    );
}

ProducerSummaryPreviewTemplate.propTypes = {
    producerPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default observer(ProducerSummaryPreviewTemplate);
